import {isValid, parseISO} from "date-fns";
import parseDate from "@DateTime/functions/parseDate";

export default function displayedDate(date: string) {
    return isValid(parseISO(date)) ? parseDate(date) : null
}